import { StyleSheet } from "react-native";
import { colors, spacing, borderRadius, textStyle } from "../../styles";

export const styles = StyleSheet.create({
  /* ─── Full-screen overlay ─── */
  panel: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 50,
    backgroundColor: colors.bg,
    flexDirection: "column",
  },

  /* ─── Header ─── */
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: 14,
    paddingHorizontal: spacing.lg,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  title: {
    fontSize: 18,
    ...textStyle.heading,
    color: colors.text,
  },
  closeBtn: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: colors.surface,
    alignItems: "center",
    justifyContent: "center",
  },
  closeBtnText: {
    color: colors.text,
    fontSize: 18,
    ...textStyle.heading,
  },

  /* ─── Messages ─── */
  messageList: {
    flex: 1,
  },
  messageListContent: {
    padding: spacing.md,
    gap: spacing.sm,
  },
  bubble: {
    maxWidth: "75%",
    paddingVertical: spacing.sm,
    paddingHorizontal: 14,
    borderRadius: 16,
  },
  aiBubble: {
    alignSelf: "flex-start",
    backgroundColor: colors.surface,
  },
  userBubble: {
    alignSelf: "flex-end",
    backgroundColor: "rgba(107,84,231,0.25)",
  },
  bubbleLabel: {
    fontSize: 10,
    color: colors.textMuted,
    marginBottom: 3,
    ...textStyle.heading,
  },
  typedTag: {
    fontWeight: "400",
    fontStyle: "italic",
  },
  bubbleText: {
    fontSize: 14,
    lineHeight: 20,
    color: colors.text,
    ...textStyle.body,
  },

  /* ─── Empty state ─── */
  emptyArea: {
    alignItems: "center",
    paddingTop: spacing.xl,
  },
  empty: {
    color: colors.textMuted,
    fontSize: 14,
    textAlign: "center",
    ...textStyle.body,
  },
  promptsArea: {
    marginTop: spacing.lg,
    width: "100%",
    maxWidth: 400,
    gap: spacing.sm,
    paddingHorizontal: spacing.lg,
  },
  promptsLabel: {
    fontSize: 12,
    color: colors.textMuted,
    marginBottom: 4,
    textAlign: "center",
    ...textStyle.body,
  },
  promptBtn: {
    backgroundColor: colors.surface,
    borderRadius: borderRadius.lg,
    paddingVertical: 12,
    paddingHorizontal: spacing.md,
    borderWidth: 1,
    borderColor: colors.border,
  },
  promptBtnText: {
    fontSize: 13,
    color: colors.textSecondary,
    ...textStyle.heading,
  },

  /* ─── Input ─── */
  inputArea: {
    flexDirection: "row",
    alignItems: "flex-end",
    gap: spacing.sm,
    padding: spacing.md,
    borderTopWidth: 1,
    borderTopColor: colors.border,
  },
  textInput: {
    flex: 1,
    borderWidth: 1,
    borderColor: colors.border,
    borderRadius: borderRadius.lg,
    backgroundColor: colors.surface,
    color: colors.text,
    paddingVertical: 10,
    paddingHorizontal: 14,
    fontSize: 14,
    lineHeight: 20,
    ...textStyle.body,
  },
  sendBtn: {
    width: 40,
    height: 40,
    borderRadius: borderRadius.lg,
    backgroundColor: colors.primary,
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  sendBtnText: {
    color: colors.white,
    fontSize: 16,
    ...textStyle.heading,
  },
});
